import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      fontWeight: 600,
      textDecoration: 'none',
      color: 'inherit'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
